document.addEventListener('DOMContentLoaded', function () {
  const feturedCharts = document.querySelectorAll('.featured-chart');
  if(feturedCharts){
    feturedCharts.forEach(function(feturedChart){
      const featuredChartTitle = feturedChart.querySelector('.featured-chart--title');
      featuredChartTitle.addEventListener('click', function () {
        const featuredChartTable = feturedChart.querySelector('.featured-chart__table');
        featuredChartTable.classList.toggle('hidden');
        featuredChartTitle.classList.toggle('opened');
      });
    });
  }
});
